import moment from 'moment';

interface PrioritySelectData {
  title: string;
  color: '#e63757' | '#F68F57' | '#2A7BE4' | '#00D27B';
  data: number;
}

function calculateDistancePercentage(startDate: string, endDate: string) {
  const startDateParsed = new Date(startDate);
  const endDateParsed = new Date(endDate);
  const currentDate = new Date();

  const totalMilliseconds = endDateParsed.getTime() - startDateParsed.getTime();
  if (totalMilliseconds <= 0) {
    return 100;
  }
  const currentMilliseconds = currentDate.getTime() - startDateParsed.getTime();
  const distancePercentage = (currentMilliseconds / totalMilliseconds) * 100;
  return Math.min(Math.max(distancePercentage, 0), 100);
}
// Create a mapping from priority titles to colors
const priorityColors: {
  [key in 'Urgent' | 'High' | 'Medium' | 'Low']: PrioritySelectData['color'];
} = {
  Urgent: '#e63757',
  High: '#F68F57',
  Medium: '#2A7BE4',
  Low: '#00D27B',
};

export function getPriorityTime({
  From,
  Till,
}: {
  From: string;
  Till: string | null;
}): PrioritySelectData {
  if (!From || !Till) {
    return {
      title: 'Open End',
      color: priorityColors['Low'],
      data: 0,
    };
  }
  const percent = calculateDistancePercentage(From, Till);

  const formattedDate = moment(Till).format('DD.MM.YYYY');

  let color;
  if (percent < 25) {
    color = priorityColors['Low'];
  } else if (percent < 50) {
    color = priorityColors['Medium'];
  } else if (percent < 75) {
    color = priorityColors['High'];
  } else {
    color = priorityColors['Urgent'];
  }

  return {
    title: formattedDate,
    color,
    data: percent,
  };
}
